import { makeQueryOptions } from '@mint-lib/api-zod-support/react-query';

import { defaultApi, defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { postSaveAndValidateRequestSchema } from '../shared/schemas/save.js';
import {
  TaskItemDeprecatedSchema,
  TaskItemSchema,
} from '../shared/schemas/tasks.js';

export const saveAndValidate = defaultApi.declareEndpoint({
  url: `ga4-service/v2/utm-configs/$utmConfigId/validate/` as const,
  method: 'POST',
  responseSchema: TaskItemDeprecatedSchema,
});

export const saveAndValidateQueryOptions = makeQueryOptions(saveAndValidate, {
  processResponse(data) {
    return data;
  },
});

export const postSaveAndValidate = defaultClient.mutation({
  url: `ga4-service/v2/utm-configs/$utmConfigId/validate/` as const,
  method: 'POST',
  requestSchema: postSaveAndValidateRequestSchema,
  responseSchema: TaskItemSchema,
  processResponse(data) {
    return data;
  },
  snakeCaseQueryParams: true,
});

export const restoreDrafts = defaultApi.declareEndpoint({
  url: `ga4-service/utm-configs/$utmConfigId/decline_drafts` as const,
  method: 'POST',
  responseSchema: z.null(),
});

export const restoreDraftsQueryOptions = makeQueryOptions(restoreDrafts, {
  processResponse(data) {
    return data;
  },
});

export const postRestoreDrafts = defaultClient.mutation({
  url: `ga4-service/utm-configs/$utmConfigId/decline_drafts` as const,
  method: 'POST',
  requestSchema: z.object({}).nullish(),
  responseSchema: z.null(),
  processResponse(data) {
    return data;
  },
});
